<template>
  <div class="cadfm-container-horizontal">
            <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle :lang="lang.Middle"></Middle>
            <!--<Right></Right>-->
 </div>
</template>

<script>
import Left from '@/components/RequestManager/Views/RequestNew/Left/Left'
import Middle from '@/components/RequestManager/Views/RequestNew/Middle/Middle'
//import Right from '@/components/RequestManager/Views/RequestNew/Right/Right'
import { mapGetters } from 'vuex'


export default {
  name: 'RequestNew',
  components:{
    Left,
    Middle,
    //Right
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
  props:{
    lang: Object
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),

  },
  
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/RequestManager/Views/RequestNew.vue